/**
 * Composable centralizado para regras de Interface do Usuário (UI) do CT Comex.
 * Evita a duplicação de funções de formatação visual nos componentes Vue.
 */
export function useUI () {
  /**
   * PADRÃO 1: STATUS (Ghost Badges)
   * Avalia o texto do status e retorna a classe CSS correspondente.
   * @param {string} textoStatus - O texto descritivo do status (ex: "Inativo", "Ativo")
   * @returns {string} Classe CSS customizada
   */
  const obterClasseStatusGhost = (textoStatus) => {
    const texto = (textoStatus || '').toUpperCase()

    if (texto.includes('INATIVO') || texto.includes('CANCELADO') || texto.includes('ENCERRADO') || texto.includes('EXPIRADO')) {
      return 'badge badge-ghost-danger'
    }
    if (texto.includes('ATIVO') || texto.includes('VIGENTE') || texto.includes('APROVADO')) {
      return 'badge badge-ghost-success'
    }

    return 'badge badge-ghost-light'
  }

  /**
   * PADRÃO 2: CATEGORIA (Cor Sólida Dinâmica)
   * Calcula uma cor de badge sólida baseada na posição do ID dentro de uma lista fixa.
   * @param {number|string} id - O ID do item a ser colorido
   * @param {Array} listasFonte - O array contendo as opções (ex: listas.moedas)
   * @returns {string} Classe CSS de background (ex: 'bg-primary')
   */
  const obterCorDinamica = (id, listasFonte) => {
    if (!id || !listasFonte || listasFonte.length === 0) return 'badge bg-secondary'

    const index = listasFonte.findIndex(m => m.idListaSistemaItem === id || m.idListaClienteItem === id)
    if (index === -1) return 'badge bg-secondary'

    const cores = ['bg-primary', 'bg-success', 'bg-info text-dark', 'bg-warning text-dark', 'bg-danger']
    return `badge ${cores[index % cores.length]}`
  }

  /**
   * PADRÃO 3: REFERÊNCIA NEUTRA (Chaves, Prefixos, Siglas)
   * Retorna um estilo limpo. O bg-body-secondary permite que a badge mude
   * automaticamente de cor quando o Bootstrap altera o tema (Light/Dark).
   * @returns {string} Classes utilitárias nativas do Bootstrap 5
   */
  const obterBadgeNeutro = () => {
    return 'badge bg-body-secondary text-body border border-secondary-subtle'
  }

  return {
    obterClasseStatusGhost,
    obterCorDinamica,
    obterBadgeNeutro
  }
}
